import React, {useState} from "react";
import {useAppDispatch, useAppSelector} from "../../../../redux/hooks";
import {Button} from "../../../buttons";
import { ReactComponent as ArrowTransferCircleFilledIcon } from '../../../../assets/icons/new/UI/ArrowTransferCircleFilled.svg';
import PillActionButton from '../../../StocksLayout/PillActionButton';
import {TClickHandlerMouseEvent} from "../../../buttons/types";
import stocksService from "../../../../api/services/stocksService";
import structuredClone from "@ungap/structured-clone";
import {WarehouseType} from "../../../../constants/Warehouses/WarehouseType";
import ModalBasic from "../../../commons/Modals/ModalBasic";
import {tasksService} from "../../../../api";
import {TaskStatusesList} from "../../../../api/services/tasks/models";
import stocksExportService from "../../../../api/services/stocksExportService";
import {defaultNotificationCreator} from "../../../../templates/Notifications";
import {setTemporaryNotifications} from "../../../../redux/notifications/actions";

// @ts-ignore
function RecalcAndExportStocksToWarehouses({disabled}) {

    const dispatch = useAppDispatch();

    const [modalOpen, setModalOpen] = React.useState(false);
    
    const { sellerId, userId } = useAppSelector(({ sellers, users }) => ({
        sellerId: sellers.currentSeller.info.data?.id,
        userId: users.currentUser.data.id
    }))

    const [inProcessing, setInProcessing] = useState<boolean>(false)

    function clickHandler() {
        setInProcessing(true)
        if (!sellerId || !userId) {
            return;
        }

        stocksExportService.manuallyRecalcAndExport(sellerId, true, false, true, [])
            .then(
                (res) => {
                    if (res.data.success) {
                        dispatch(setTemporaryNotifications(
                            defaultNotificationCreator({
                                title: "Остатки пересчитаны и отправлены",
                                description: "",
                                iconType: "success"
                            })
                        ))
                        setModalOpen(false)
                    }
                },
                (err) => {
                    dispatch(setTemporaryNotifications(
                        defaultNotificationCreator({
                            title: "Не удалось отправить остатки",
                            description: err.message(),
                            iconType: "warning"
                        })
                    ))
                }
            )
            .catch((err) => {
                dispatch(setTemporaryNotifications(
                    defaultNotificationCreator({
                        title: "Не удалось пересчитать и отправить остатки",
                        description: err.message,
                        iconType: "warning"
                    })
                ))
            })
            .finally(() => setInProcessing(false))
    }

    function clickHandlers() {
        clickHandler();
    }
    
    return (
        <>
            <PillActionButton
                icon={ArrowTransferCircleFilledIcon}
                label="Пересчитать и отправить"
                title={disabled ? 'Для начала настройте склад для отправки' : 'Пересчитать и отправить'}
                disabled={disabled}
                loading={inProcessing}
                onClick={() => setModalOpen(true)}
            />
            <ModalBasic id="confirmExportStocksToWarehouses" customSize="max-w-sm" title="" modalOpen={modalOpen} setModalOpen={setModalOpen}>
                <div className={`py-5`}>
                    <div>Подтверждаете перерасчет и отправку остатков?</div>
                    <Button
                        appearance="primary"
                        customClassName="button-add px-[50px] mt-5"
                        clickHandler={clickHandlers}
                        loading={inProcessing}
                    >Да</Button>
                </div>
            </ModalBasic>
        </>

    );
}

export default RecalcAndExportStocksToWarehouses;
